import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";

export class UpdateKundorderradAlternativaHandelssortimentCommand extends BasicCommand<UpdateKundorderradAlternativaHandelssortimentCommand> {
    primaryKey: import("../../../../../../common/services/cqs/IPrimaryKey").IPrimaryKey<UpdateKundorderradAlternativaHandelssortimentCommand>;
    kundorderradId: number;
    id: number;
    handelssortimentId: number;
    inmatningshandelssortimentId?: number;
    manuellPaAo: boolean;
    egenskapskodX: boolean;
    endastCentralaKop: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "KundorderAlteranativthandelssortiment";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "UpdateKundorderradAlternativaHandelssortimentCommand";

    constructor(kundorderradId: number, id: number) {
        super("UpdateKundorderradAlternativaHandelssortimentCommand", "kundorderrad", CommandType.Replace);
        this.kundorderradId = kundorderradId;
        this.id = id;
    }
}
